import {
  FAILURE,
  GET_USER_TYPES,
  INSTITUITON_LIST_SUCCESS,
  INSTITUITON_USER_TYPE_LIST_SUCCESS,
  OTP_REQUEST_SUCCESS,
  REQUEST,
  UPDATE_USER_FORM_VALUES,
  UPDATE_USER_TYPE,
  USER_CREATE,
  VERIFY_OTP_REQUEST_SUCCESS,
  STATE_LIST_OPTIONS_SUCCESS,
  DISTRICT_LIST_OPTIONS_SUCCESS,
  DISTRICT_LIST_OPTIONS_REQUEST,
  DISTRICT_LIST_OPTIONS_FAILURE,
  UPLOAD_USER_IMAGE,
  USER_FORM_ERRROS,
  CLEAR_USER_ERROR_OBJ,
  VERIFY_MOBILE_OTP_REQUEST_SUCCESS,
  MOBILE_OTP_REQUEST_SUCCESS,
  UPDATE_FROM_DETAILS,
  SPORT_LIST_AND_KIT_LIST,
  FETCHED_USER_DETAILS,
  CHANGE_HIDE_STATUS,
  REGISTRATION_LISTING,
  CORRECTION_DATA,
  LOGIN_USER,
  FETCH_OTHERS_SUBCATEGORY,
  FORGOT_PASSWORD_SENT_REQUEST_FOR_OTP_REQUEST,
  FORGOT_PASSWORD_OTP_REQUEST_SUCCESS,
  FORGOT_PASSWORD_OTP_REQUEST_FAILURE,
  OTP_VERIFY_REQUEST_OF_FORGOT_PASS,
  OTP_VERIFY_SUCCESS_OF_FORGOT_PASS,
  OTP_VERIFY_FAILURE_OF_FORGOT_PASS,
} from "./actionTypes";

const intialState = {
  steps: +localStorage.getItem("steps") || 0,
  maxSteps: 0,
  category_type: localStorage.getItem("category_type") || "{}",
  sentOTP: false,
  mobileSentOTP: false,
  ISLOADING: false,
  ISERROR: false,
  otpVerified: false,
  mobileOtpVerified: false,
  userTypesOptions: [],
  institutionListOptions: [],
  institutionlUserType: [],
  stateListOptions: [],
  stateListLoding: false,
  stateListError: false,
  //districtListOptions
  districtListOptions: [],
  districtListLoding: false,
  districtListError: false,
  sportList: [],
  KitList: [],
  registerationListing: {},
  correctionData: {},
  correctionDataFields: {},
  user: JSON.parse(localStorage.getItem("user") || "{}"),
  hide_status_page: true,
  othersSubCategory: [],
};

//for grabbing the form values
const formValues = {
  status: "ongoing",
  id: JSON.parse(localStorage.getItem("user") || "{}")?.id,
};
const userAttachements = {};
const formErrorsObj = {};
//For Managing the user steps
export const CHANGE_STEP = "CHANGE_STEP";
export const ADD = "ADD";
export const DEC = "DEC";
export const JUMP = "JUMP";
export const CHANGES_AFTER_USER_TYPE = "UPDATE_MAX_STEPS";
const RESET_APP = "RESET_APP";

const RegistrationReducer = (
  state = {
    formValues: { ...formValues },
    userAttachements: { ...userAttachements },
    formErrorsObj: { ...formErrorsObj },
    ...intialState,
  },
  { type, payload }
) => {
  switch (type) {
    case REQUEST:
      return {
        ...state,
        ISLOADING: true,
        ISERROR: false,
      };

    case LOGIN_USER: {
      let steps = payload?.user?.steps;
      let category_type = {
        id: payload?.user?.category_type ? payload?.user?.category_type : null,
      };
      localStorage.setItem("access_token", payload?.authorisation?.token);
      localStorage.setItem("user", JSON.stringify(payload?.user));
      localStorage.setItem("type", JSON.stringify(payload?.type));
      steps && localStorage.setItem("steps", JSON.stringify(steps));
      category_type.id &&
        localStorage.setItem("category_type", JSON.stringify(category_type));
      let obj = {
        ...state,
        ISLOADING: false,
        ISERROR: false,
        category_type: category_type,
      };

      if (steps) {
        obj.steps = steps;
        obj.maxSteps = steps;
      }

      if (category_type) {
        obj.category_type = JSON.stringify(category_type);
      }
      return obj;
    }
    case OTP_REQUEST_SUCCESS:
      return {
        ...state,
        ISLOADING: false,
        sentOTP: true,
      };
    case VERIFY_OTP_REQUEST_SUCCESS:
      return {
        ...state,
        ISLOADING: false,
        otpVerified: true,
      };
    case MOBILE_OTP_REQUEST_SUCCESS: {
      return {
        ...state,
        ISLOADING: false,
        mobileSentOTP: true,
      };
    }
    case VERIFY_MOBILE_OTP_REQUEST_SUCCESS:
      return {
        ...state,
        ISLOADING: false,
        mobileOtpVerified: true,
        mobileSentOTP: false,
      };
    case GET_USER_TYPES:
      return {
        ...state,
        ISLOADING: false,
        userTypesOptions: payload,
      };
    case INSTITUITON_LIST_SUCCESS:
      return {
        ...state,
        ISLOADING: false,
        institutionListOptions: payload?.data,
      };
    case INSTITUITON_USER_TYPE_LIST_SUCCESS:
      return {
        ...state,
        ISLOADING: false,
        institutionlUserType: payload.data,
      };

    //State listing

    case STATE_LIST_OPTIONS_SUCCESS:
      return {
        ...state,
        stateListOptions: payload,
        stateListLoding: false,
      };

    //District listing

    case DISTRICT_LIST_OPTIONS_REQUEST:
      return {
        ...state,
        districtListLoding: false,
      };
    case DISTRICT_LIST_OPTIONS_SUCCESS:
      return {
        ...state,
        districtListOptions: payload,
        districtListLoding: false,
      };
    case DISTRICT_LIST_OPTIONS_FAILURE:
      return {
        ...state,
        districtListError: true,
        districtListLoding: false,
      };
    case SPORT_LIST_AND_KIT_LIST:
      return {
        ...state,
        ISERROR: false,
        ISLOADING: false,
        sportList: payload?.Sportlist?.data,
        kitList: payload?.KitList?.data,
      };

    case FETCH_OTHERS_SUBCATEGORY:
      return {
        ...state,
        ISERROR: false,
        ISLOADING: false,
        othersSubCategory: payload,
      };

    case USER_CREATE: {
      localStorage.setItem("access_token", payload?.authorisation?.token);
      localStorage.setItem("user", JSON.stringify(payload?.user));

      return {
        ...state,
        ISLOADING: false,
        userTypesOptions: payload.data,
        user: payload?.user,
        formValues: { ...state.formValues, id: payload?.user?.id,email: payload?.user?.email },
      };
    }
    case UPDATE_USER_TYPE: {
      delete payload.image;
      // localStorage.setItem("category_type", JSON.stringify(payload));
      return {
        ...state,
        category_type: JSON.stringify(payload),
      };
    }
    case UPDATE_USER_FORM_VALUES: {
      return { ...state, formValues: { ...state.formValues, ...payload } };
    }
    case USER_FORM_ERRROS: {
      return {
        ...state,
        formErrorsObj: { ...state.formErrorsObj, ...payload },
      };
    }
    case CLEAR_USER_ERROR_OBJ: {
      return {
        ...state,
        formErrorsObj: { },
      };

    }
    case UPLOAD_USER_IMAGE: {
      return {
        ...state,
        ISLOADING: false,
        userAttachements: { ...state.userAttachements, ...payload },
      };
    }

    case UPDATE_FROM_DETAILS: {
      return {
        ...state,
        ISLOADING: false,
        ISERROR: false,
        formValues: { ...state.formValues, ...payload.data },
        maxSteps: payload?.data?.steps,
      };
    }

    case FETCHED_USER_DETAILS: {
      return {
        ...state,
        ISLOADING: false,
        ISERROR: false,
        steps: Number(payload.steps || 1),
        maxSteps: Number(payload.maxSteps || 1),
        formValues: { ...payload.form },
        userAttachements: { ...payload?.attachmentObj },
        hide_status_page: payload?.hide_status_page,
        updated_at: payload?.updated_at,
      };
    }
    case CHANGE_HIDE_STATUS:
      return {
        ...state,
        hide_status_page: payload,
      };

    case REGISTRATION_LISTING:
      return {
        ...state,
        ISLOADING: false,
        ISERROR: false,
        registerationListing: payload,
      };
    case CORRECTION_DATA: {
      let data = payload?.data?.registration_correction;
      let obj = {};
      for (let i = 0; i < data.length; i++) {
        const current = data[i];

        let regimageval = current?.key;
        if (/^registration_doc_/.test(regimageval)) {
          obj[current.label] = current;
        } else {
          obj[current.key] = current;
        }
      }
      const newFormError = {};

      for (const key in obj) {
        newFormError[key] = obj[key].remark;
      }

      return {
        ...state,
        ISLOADING: false,
        ISERROR: false,
        correctionData: payload.data,
        correctionDataFields: obj,
        formErrorsObj: { ...state.formErrorsObj, ...newFormError },
      };
    }

    case FAILURE:
      return {
        ...state,
        ISLOADING: false,
        ISERROR: true,
      };

    case CHANGE_STEP: {
      if (payload.operation === ADD) {
        localStorage.setItem("steps", state.steps + 1);
        return { ...state, steps: state.steps + 1 };
      } else if (payload.operation === DEC) {
        localStorage.setItem("steps", Math.max(0, state.steps - 1));
        return { ...state, steps: Math.max(0, state.steps - 1) };
      } else if (payload.operation === JUMP) {
        localStorage.setItem("steps", payload.value);
        return { ...state, steps: payload.value };
      } else {
        return { ...state };
      }
    }

    case CHANGES_AFTER_USER_TYPE:
      return {
        ...state,
        maxSteps: payload.value,
        formValues: { ...state.formValues, sub_category_type: null },
      };
    //forgot pass
    case FORGOT_PASSWORD_SENT_REQUEST_FOR_OTP_REQUEST:
      return { ...state, ISLOADING: true, ISFAILURE: false };
    case FORGOT_PASSWORD_OTP_REQUEST_SUCCESS:
      return { ...state, ISLOADING: false };
    case FORGOT_PASSWORD_OTP_REQUEST_FAILURE:
      return { ...state, ISFAILURE: true, ISLOADING: false };

    //otpverify for forgot pass
    case OTP_VERIFY_REQUEST_OF_FORGOT_PASS:
      return { ...state, ISLOADING: true, ISFAILURE: false };
    case OTP_VERIFY_SUCCESS_OF_FORGOT_PASS:
      return { ...state, ISLOADING: false };
    case OTP_VERIFY_FAILURE_OF_FORGOT_PASS:
      return { ...state, ISFAILURE: true, ISLOADING: false };
    case RESET_APP:
      return {
        formValues: {},
        userAttachements: {},
        formErrorsObj: {},
        ...intialState,
        step: 0,
      };
    default:
      return state;
  }
};

export default RegistrationReducer;

export const ChangeStep = (payload) => {
  // example of payload
  // { operation :"ADD"/"DEC",value:1}
  return { type: CHANGE_STEP, payload };
};
export const changes_after_user_type_func = (payload = {}) => {
  // example of payload
  // { operation :"ADD"/"DEC",value:1}
  return { type: CHANGES_AFTER_USER_TYPE, payload };
};

export const resetRedux = () => {
  // example of payload
  console.log("resetRedux");
  return { type: RESET_APP };
};
